// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"36cd56a9456b9e56ee16","883":"0cf2a455b23802d0f56d"}[chunkId] + ".js";
};